import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FileDescriptorBase } from 'src/app/swagger-api';

@Component({
  selector: 'app-activities-display-popup',
  templateUrl: './activities-display-popup.component.html',
  styleUrls: ['./activities-display-popup.component.scss'],
})
export class ActivitiesDisplayPopupComponent {
  @Input({ required: true }) public rowIndex: number;
  @Input({ required: true }) public entityName: string;
  @Input({ required: true }) public value: FileDescriptorBase;
  @Input({ required: true }) public dataTestId: string;

  @Output() public displayPopup: EventEmitter<FileDescriptorBase> = new EventEmitter<FileDescriptorBase>();

  public onDisplayPopup(value: FileDescriptorBase): void {
    this.displayPopup.emit(value);
  }
}
